import { Box, Modal, Tooltip } from "@mui/material";
import React, { useEffect, useState } from "react";
import CancelPresentationIconButton from "../../../common/components/Buttons/CancelPresentationIconButton";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, useFormContext } from "react-hook-form";
import CreateableSelect from "../../../common/components/FormFields/CreateableSelect";
import InputField from "../../../common/components/FormFields/InputField";
import CommonButton from "../../../common/components/Buttons/CommonButton";
import { UseCheckConsecutiveCharacters } from "../../../common/components/Custom Hooks/UseCheckConsecutiveCharacters";
import { getAllergies } from "../services/EMRServices/emrServices";
import CommonTransactionTable from "../../../common/components/CommonTable/CommonTransactionTable";
import { warningAlert } from "../../../common/components/Toasts/CustomToasts";
import { DeleteIcon, EditIcon } from "./EmrCommonAsset/Asset";
import { useEMRGeneralContext } from "../newGeneralEmr/EMRContextGeneral";
import ConfirmationModal from "../../../common/components/ConfirmationModal";

export default function AllergiesModal(props) {
  const {
    allergiesData,
    setAllergiesData,
    dataAllergies,
    setDataAllergies,
    markFavoriteData,
    setMarkFavoriteData,
  } = props;
  const [allergiesTypeList, setAllergiesTypeList] = useState();
  const [row, setRow] = useState(null);
  const [editData, setEditData] = useState(false);
  const [index, setIndex] = useState(null);
  const [openPost, setOpenPost] = useState(false);
  const [saveData, setSaveData] = useState(false);
  const [existingAllergyData, setExistingAllergyData] = useState([]);
  //   const [selectedChipValue, setSelectedChipValue] = useState(null);
  const validationSchema = yup.object().shape({
    allergyDescription: yup.string().required("Required"),
    allergyType: yup
      .object()
      .nullable()
      .shape({
        value: yup.string(),
        label: yup.string(),
      })
      .required("Please Select Allergies Type"),
  });

  const {
    handleSubmit,
    reset,
    formState: { errors },
    control,
    register,
    setValue,
    watch,
  } = useFormContext({
    // resolver: yupResolver(validationSchema),
    // defaultValues: defaultValues,
  });

  useEffect(() => {
    if (props.selectedAllergie !== null) {
      console.log("selectedAllergie", props.selectedAllergie);
      setValue("allergyType", props.selectedAllergie);
      console.log("selectedChips", props.selectedChips);

      props.setSelectedChips([props.selectedChips, props.selectedAllergie]);
    }
  }, [props.selectedAllergie]);
  // const handleChange = (e) => {
  //   console.log(e);
  //   if (e.length > 0) {
  //     if (UseCheckConsecutiveCharacters(e)) {
  //       getAllergies(e)
  //         .then((response) => {
  //           // console.log("Complaints", response.data.result);
  //           setAllergiesTypeList(response.data.result);
  //         })
  //         .catch((response) => {
  //           console.log(response);
  //         });
  //     }
  //   } else if (e === "" || e === undefined || e === null) {
  //     setAllergiesTypeList([]);
  //   }
  // };
  let allergyType = watch("allergyType");
  let description = watch("allergyDescription");
  console.log("props.edit", props.edit);
  const handleSubmitAllergie = (data) => {
    if (props.edit === false && editData === false) {
      let obj = {
        allergyType: allergyType?.label,
        allergyDescription: description,
        isNew:
          allergyType?.__isNew__ !== undefined &&
          allergyType?.__isNew__ === true
            ? true
            : false,
      };
      let temp = dataAllergies.some(
        (item) => item.allergyType === allergyType?.label
      );
      console.log("temp4567890", temp);

      if (temp === true) {
        warningAlert("Already Present Record..!");
      } else {
        if (allergyType !== null && allergyType !== undefined) {
          setDataAllergies((prevState) => [...prevState, obj]);
          setValue("allergyType", null);
          setValue("allergyDescription", "");
        } else {
          warningAlert("Please Fill The Record");
        }
      }
    } else if (props.edit === true) {
      let updateobj = {
        allergyType: allergyType?.label,
        allergyDescription: description,
        isNew:
          allergyType?.__isNew__ !== undefined &&
          allergyType?.__isNew__ === true
            ? true
            : false,
      };
      let duplicateInd = allergiesData?.findIndex(
        (item, idx) =>
          item.allergyType === allergyType?.label && idx !== props.index
      );

      console.log("duplicateInd555", duplicateInd);
      if (duplicateInd === -1) {
        if (allergyType !== null && allergyType !== undefined) {
          let reqArr = [...allergiesData];
          console.log("reqArr", reqArr);
          reqArr.splice(props.index, 1, updateobj);
          setAllergiesData(reqArr);
          setDataAllergies(reqArr);
          props.setEditOpen(false);
          props.setEdit(false);
          setValue("allergyType", null);
          setValue("allergyDescription", "");
        } else {
          warningAlert("Please Fill The Record");
          setOpenPost(false);
        }
      } else {
        warningAlert("Duplicate found, update not applied");
      }
    } else if (editData === true) {
      let updateobj = {
        allergyType: allergyType?.label,
        allergyDescription: description,
        isNew:
          allergyType?.__isNew__ !== undefined &&
          allergyType?.__isNew__ === true
            ? true
            : false,
      };

      // Check if there's a duplicate, excluding the current index
      let duplicateInd = dataAllergies?.findIndex(
        (item, idx) => item.allergyType === allergyType?.label && idx !== index
      );

      console.log("duplicateInd", duplicateInd);
      if (duplicateInd === -1) {
        if (allergyType !== null && allergyType !== undefined) {
          // No duplicates found, or it's the same index
          let reqArr = [...dataAllergies];
          reqArr.splice(index, 1, updateobj);
          console.log("Updated reqArr", reqArr);
          setDataAllergies(reqArr);
          setEditData(false);
          setValue("allergyType", null);
          setValue("allergyDescription", "");
        } else {
          warningAlert("Please Fill The Record");
          setOpenPost(false);
        }
      } else {
        warningAlert("Duplicate found, update not applied");
      }
    }
  };
  const handleSaveComplaints = () => {
    props.setOpenAllergiesModal(false);
    props.setSave(true);
    setEditData(false);
    setSaveData(false);
  };

  useEffect(() => {
    if (props.edit === true) {
      let allergiesObj = {
        label: props.row?.Allergies,
        value: props.row?.Allergies,
      };
      console.log("props.row", props.row);
      setValue("allergyType", allergiesObj);
      setValue("allergyDescription", props.row?.Description);
    }
  }, [props.edit]);

  useEffect(() => {
    if (row !== null) {
      console.log("row67890", row);
      let allergiesObj = {
        label: row?.Allergies,
        value: row?.Allergies,
      };

      setValue("allergyType", allergiesObj);
      setValue("allergyDescription", row?.Description);
    }
  }, [row]);
  function deleteRow(index) {
    const newComplaintsData = [...dataAllergies];
    newComplaintsData.splice(index, 1);
    // setMedicationData(newComplaintsData);
    setDataAllergies(newComplaintsData);
    setSaveData(false);
  }
  const renderAction = (row, index) => {
    return (
      <div className="flex gap-2">
        <Tooltip title="Edit">
          <button
            type="button"
            onClick={() => {
              setRow(row);
              setEditData(true);
              setIndex(index);
            }}
          >
            <EditIcon />
          </button>
        </Tooltip>

        <Tooltip title="Delete">
          <button
            type="button"
            onClick={() => {
              deleteRow(index);
              setSaveData(true);
            }}
          >
            <DeleteIcon />
          </button>
        </Tooltip>
      </div>
    );
  };
  const handleCloseModel = () => {
    setOpenPost(false);
    setSaveData(false);
    setDataAllergies(existingAllergyData);
    props.setOpenAllergiesModal(false);
    props.setEditOpen(false);
    props.setEditOpen(false);
    props.setEdit(false);
    setEditData(false);
    setValue("allergyType", null);
    setValue("allergyDescription", "");
  };
  useEffect(() => {
    if (props.openAllergiesModal) {
      console.log("jjjj");
      setExistingAllergyData(dataAllergies);
    }
  }, [props.openAllergiesModal]);
  console.log("existingAllergyData", existingAllergyData);
  return (
    <div>
      <Modal
        open={props.openAllergiesModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "85%",
            height: "60%",
            // maxHeight: "75%",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            overflow: "auto",
            overflowY: "scroll",
          }}
        >
          <div className="text-base font-semibold  mb-4 flex justify-between">
            <h1>Allergies</h1>
            <div className="-mt-2">
              <CancelPresentationIconButton
                onClick={() => {
                  if (saveData === true) {
                    setOpenPost(true);
                  } else {
                    props.setOpenAllergiesModal(false);
                    props.setEditOpen(false);
                    props.setEditOpen(false);
                    props.setEdit(false);
                    setEditData(false);
                    setValue("allergyType", null);
                    setValue("allergyDescription", "");
                  }
                }}
              />
            </div>
          </div>
          <div>
            {props.edit === false && editData === false ? (
              <>
                {markFavoriteData?.allergy?.length > 0 ? (
                  <fieldset
                    className="flex space-x-2 flex-wrap py-2 pl-2"
                    //   disabled={isDisableChips}
                  >
                    {markFavoriteData?.allergy &&
                      markFavoriteData?.allergy.map((item, index) => {
                        {
                          /* const isSelected =
                          props.selectedChips &&
                          props.selectedChips.some(
                            (row) => row?.label === item?.label
                          ); */
                        }

                        return (
                          <>
                            {/* {item.isCommon && ( */}
                            <button
                              type="button"
                              // className="border border-black center relative inline-block select-none whitespace-nowrap rounded-full bg-white py-2 px-3.5 align-baseline text-xs  leading-none text-black"
                              key={index}
                              className={`mr-[5px] mb-1 capitalize h-[27px] px-3 w-max rounded text-sm border border-gray-300 whitespace-nowrap ${
                                dataAllergies?.some(
                                  (val) => val?.allergyType === item.label
                                )
                                  ? "bg-[#32819b] text-white rounded-full border"
                                  : "text-black rounded-full border"
                              }`}
                              // disabled={selectedChips.includes(item) ? true : false}
                              onClick={() => {
                                props.setSelectedChips([
                                  props.selectedChips,
                                  item,
                                ]);
                                console.log("Item", item);
                                // let allergyData = {
                                //   allergyType: item,
                                // };
                                setValue("allergyType", item);
                                // onSubmit(allergyData);
                              }}
                            >
                              {item.label}
                            </button>
                            {/* )} */}
                          </>
                        );
                      })}
                  </fieldset>
                ) : null}
              </>
            ) : null}
          </div>

          <div>
            {/* <form onSubmit={handleSubmit(onSubmit)}> */}
            <div className="flex space-x-2 my-2">
              <div className="w-5/12 ">
                <CreateableSelect
                  // ref={selectRef}
                  focused={true}
                  control={control}
                  error={errors.allergyType}
                  name="allergyType"
                  label="Allergies Type *"
                  placeholder="Allergies Type *"
                  dataArray={allergiesTypeList}
                  isSearchable={false}
                  // handleChange={handleChange}
                  // onInputChange={handleChange}
                  autoFocus
                />
              </div>

              <div className="w-5/12">
                <InputField
                  name="allergyDescription"
                  variant="outlined"
                  label=" Description "
                  error={errors.allergyDescription}
                  control={control}
                />
              </div>
              {props.edit === false && editData === false ? (
                <CommonButton
                  label="Add"
                  type="button"
                  onClick={() => {
                    handleSubmitAllergie();
                    setSaveData(true);
                  }}
                  className="addButton bg-customBlue text-white"
                />
              ) : (
                <CommonButton
                  label="Update"
                  type="button"
                  onClick={() => {
                    handleSubmitAllergie();
                    setSaveData(true);
                  }}
                  className="addButton bg-customBlue text-white"
                />
              )}
            </div>
            {/* </form> */}
          </div>
          <div>
            {props.edit === false ? (
              <>
                {dataAllergies?.length > 0 ? (
                  <CommonTransactionTable
                    dataResult={dataAllergies.map((row) => ({
                      Allergies: row.allergyType,
                      Description: row.allergyDescription,
                      isNew: row?.isNew,
                    }))}
                    renderActions={renderAction}
                    highlightRow={false}
                    removeHeaders={["isNew"]}
                  />
                ) : null}
              </>
            ) : null}
          </div>
          <div>
            {props.edit === false ? (
              <>
                {dataAllergies?.length > 0 ? (
                  <>
                    <div className="flex justify-end space-x-2 my-2">
                      <CommonButton
                        type="button"
                        label="Reset"
                        className="resetButton border border-red-500 text-red-500"
                        onClick={() => {
                          setDataAllergies([]);
                          setAllergiesData([]);
                          setValue("allergyType", null);
                          setValue("allergyDescription", "");
                          setEditData(false);
                        }}
                      />
                      <CommonButton
                        type="button"
                        label="Save"
                        className="saveButton bg-customGreen text-white"
                        onClick={() => {
                          handleSaveComplaints();
                          setValue("allergyType", null);
                          setValue("allergyDescription", "");
                        }}
                      />
                    </div>
                  </>
                ) : null}
              </>
            ) : null}
          </div>
        </Box>
      </Modal>
      <ConfirmationModal
        confirmationOpen={openPost}
        confirmationHandleClose={() => {
          setOpenPost(false);
        }}
        confirmationSubmitFunc={() => {
          handleCloseModel();
        }}
        confirmationLabel="Confirmation "
        confirmationMsg="Added Data Not Saved Do You Still Want to Close ?"
        confirmationButtonMsg="Yes"
      />
    </div>
  );
}
